// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosError } from 'axios';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { getIltCourseContentsData } from '../../../apis/iltCourse';
import { RootAction, actionCreatorsList } from '../../rootActionCreator';
const { getIltCourseContentsDataActions } = actionCreatorsList;

const outputActions = {
  success: getIltCourseContentsDataActions.success,
  failure: getIltCourseContentsDataActions.failure
};

type RequestActionTypes = ActionType<
  typeof getIltCourseContentsDataActions.request
>;
type OutputActionTypes = ActionType<typeof outputActions>;

const getIltCourseContentsDataEpic = (
  action$: Observable<RootAction>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      // action filter
      getType(getIltCourseContentsDataActions.request)
    ),
    switchMap((action: RequestActionTypes) => {
      // prepare api params
      const { id } = action.payload;
      // send api promise
      return getIltCourseContentsData(id)
        .then(response => {
          const {
            chapters,
            progress,
          } = response.data;
          // handle success case here
          return getIltCourseContentsDataActions.success({
            id,
            chapters,
            progress,
          });
        })
        .catch((error: AxiosError) => {
          // handle error case here
          console.log(error)
          return getIltCourseContentsDataActions.failure({ error });
        });
    })
  );
};

export { getIltCourseContentsDataEpic as default};
